import React, { useMemo } from 'react';
import { Tooltip } from 'devextreme-react';
import './SampleTubesPanel.scss';

export interface TmBcListDTO {
  IdEs: number;
  Color: string;
  CbNombre: string;
  TmNombre: string;
}

interface GroupedTube {
  Color: string;
  CbNombre: string;
  TmNombre: string;
  count: number;
}

interface SampleTubesPanelProps {
  data: TmBcListDTO[];
}

export const SampleTubesPanel: React.FC<SampleTubesPanelProps> = ({ data }) => {
  const groupedData = useMemo((): GroupedTube[] => {
    if (!data || data.length === 0) return [];

    const map = new Map<string, GroupedTube>();
    data.forEach((item) => {
      const key = `${item.Color}|${item.CbNombre}|${item.TmNombre}`;
      if (map.has(key)) {
        map.get(key)!.count++;
      } else {
        map.set(key, {
          Color: item.Color,
          CbNombre: item.CbNombre,
          TmNombre: item.TmNombre,
          count: 1,
        });
      }
    });

    return Array.from(map.values()).sort((a, b) => a.TmNombre.localeCompare(b.TmNombre));
  }, [data]);

  return (
    <div className='sample-tubes-panel'>
      <div className='panel-title'>Muestras ({groupedData.length})</div>
      <div className='panel-content'>
        {groupedData.length === 0 ? (
          <div className='no-tubes-message'>Sin muestras</div>
        ) : (
          groupedData.map((tube, i) => (
            <div key={i} className='tube-row'>
              <div className='test-tube'>
                <div className='liquid' style={{ backgroundColor: tube.Color || '#888' }}></div>
              </div>
              <div className='tube-info'>
                <span className='tube-sample-type'>{tube.TmNombre}</span>
                <span className='tube-barcode'>{tube.CbNombre}</span>
              </div>
              {tube.count > 1 && (
                <div style={{ flexShrink: 0, position: 'relative', width: 16, height: 16 }}>
                  <span id={`tube-count-${i}`} className='tube-count'>{tube.count}</span>
                  <Tooltip target={`#tube-count-${i}`} showEvent='mouseenter' hideEvent='mouseleave' position='left'>
                    <div>{tube.count} exámenes comparten esta etiqueta</div>
                  </Tooltip>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};
